import { createApp, markRaw } from 'vue'
import App from './App.vue'

import {createPinia } from 'pinia'

import router from './router/router'


import Oruga from '@oruga-ui/oruga-next'
/*
import { Config as OrugaConfig, 
   OButton, OCheckbox, OField, OInput, 
   OTabs, OTabItem,
   ONotification,
} from '@oruga-ui/oruga-next' 
*/
import { bulmaConfig } from '@oruga-ui/theme-bulma'
import '@oruga-ui/theme-bulma/dist/bulma.css'
import './styles/ob_sb_styles.scss'
import '@creativebulma/bulma-tooltip/dist/bulma-tooltip.min.css'


import IconPrefix from '@/components/sbstandard/icon-prefix.vue'

const pinia = createPinia()
pinia.use(({ store }) => { 
   store.$router = markRaw(router) 
})

createApp(App)
   .use( pinia )
   .use(router)
   // Register oruga components //? as my-component
   .use(Oruga, bulmaConfig) /*
   .component('o-field', OField)
      .component('o-checkbox', OCheckbox)
      .component('o-button', OButton)
      .component('o-input', OInput)
      .component('o-notification', ONotification)
   .component('o-tabs', OTabs).component('o-tab-item', OTabItem)
   .use(OrugaConfig, bulmaConfig)
*/
   .component('icon', IconPrefix)
   .mount('#app');

